import { ArrowBigDown } from "lucide-react";

type InsuranceUnprotectedProps = {
  value?: number;
};

const InsuranceUnprotected = (props: InsuranceUnprotectedProps) => (
  <div
    className={`relative bg-white border border-gray5 shadow-md rounded-2xl p-5 transition hover:shadow-lg hover:scale-[1.01] animate-pulse font-semibold 
            ${typeof props.value === "number" && props.value > 0 ? 'animate-pulse-color' : ''}`}
    id="card-vehicles-without-protection">
    <div className="grid grid-cols-[1fr_auto] gap-4 items-center justify-center">
      <div className="flex flex-col justify-center  items-center">
        <div className="mb-2 flex items-center gap-2">
          <h3 className={`text-xl font-semibold text-red`}>Veículos sem proteção</h3>
        </div>
        <p className={`text-3xl font-semibold text-red`}>
          {typeof props.value === "number"
            ? props.value
            : 0}
        </p>
      </div>
      <div className="flex flex-col justify-between items-end h-full gap-2 items-center">
        <ArrowBigDown className={`w-12 h-12 text-green-600 fill-current stroke-none`} />
        <span className="bg-white text-black text-xs font-bold px-2 py-0.5 rounded-full shadow animate-ping-fast">
          {typeof props.value === "number"
            ? props.value
            : 0}
        </span>
      </div>
    </div>
  </div>
);

export default InsuranceUnprotected;